import React from 'react';
import {WorkbenchStateContext} from "../context/WorkbenchContext";
import BaseProps from "../../types/BaseProps";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import Icon from "../../common/Icon";
import {DialogService} from "../../common/Dialog";
import SecurityService from "../../services/security-service";
import classNames from "classnames";

import "./UserToolbar.scss";
import {UserInfo} from "../../types/UserInfo";

class UserToolbar extends React.Component<BaseProps> {

  static contextType = WorkbenchStateContext;

  constructor(props: {}) {
    super(props);
    this.logout = this.logout.bind(this);
  }

  private logout() {
    DialogService.confirm({
      message: <LogoutConfirmationMessage/>,
      onConfirm: () => SecurityService.logout()
    });
  }

  render() {
    if (!this.context.security?.enabled) {
      return false;
    }
    const classes = classNames('UserToolbar', 'box-shadow', this.props.className);
    return (
      <span className={classes}>
        <DropdownButton id="UserToolbarDropdownToggle"
                        title={<UserMenuHeader user={this.context.security.user}/>}
                        variant="primary">
          <Dropdown.Item onClick={this.logout}>
            <LogoutMenuItem/>
          </Dropdown.Item>
        </DropdownButton>
      </span>
    );
  }
}

function UserMenuHeader(props: { user?: UserInfo }) {
  return (
    <span className="UserMenuHeader">
      <Icon icon="user-circle"/> {props.user?.username || 'User'}
    </span>
  );
}

function LogoutMenuItem() {
  return (
    <span className="LogoutAction">
      <Icon icon="sign-out-alt" className="mr-1"/>
      Logout
    </span>
  );
}

function LogoutConfirmationMessage() {
  return (
    <p>You may have unsaved changes. Are you sure you want to log out?</p>
  );
}

export default UserToolbar;
